import { keyBy, mapValues, union } from 'lodash'
import { useRouter } from 'next/router'
import Link from 'next/link'

import { DEFAULT_CART } from '../../constants'
import { getProductCategories, getProductsById, getProductColors, getStaticDate } from '../../lib'
import { withSession } from '../../utils/server'
import { Layout, Currency, CartSummary } from '../../components/front'
import { useCart } from '../../components/front/Cart'
import { useUser } from '../../components/front/User'

export let getServerSideProps = withSession(async ({ req }) => {
    const hier = await getProductCategories()
    const data = await getStaticDate()
    let cart = req.session?.get('usercart') || { ...DEFAULT_CART }

    const product_ids = union(
        cart.items.map((p) => p.variant_id),
        cart.items.map((p) => p.product_id)
    )
    const valid_products = await getProductsById(product_ids)

    const cartProducts = mapValues(keyBy(valid_products, 'id'), (i) => i)
    const colors = await getProductColors()

    return {
        props: {
            productCategories: hier,
            cartProducts: cartProducts,
            colorMap: colors.byIds,
            footer: data['about_footer'].content
        }
    }
})

export default function Cart({ productCategories, cartProducts, colorMap, footer }) {
    const router = useRouter()
    const cart = useCart()
    const user = useUser()

    async function updateQty(product, qty) {
        product.updatingQty = true
        const currentQty = cart.get(product.id)?.qty || 1

        if (qty === '+') {
            qty = currentQty + 1
            //check for max stock
        } else if (qty === '-') {
            qty = currentQty - 1
        } else qty = Number(qty)
        if (qty < 1) qty = 1

        const stock = Number(product?.metas?.stock?.value)
        if (isNaN(stock)) return

        if (qty > stock) qty = stock
        if (stock <= 0) qty = 0

        await cart.update(product.id, qty)
        product.updatingQty = false
    }

    const CartAction = user.isLoggedIn ? (
        <>
            <button
                type="button"
                className="bg-purple-400 text-purple-100 text-lg px-4 py-3 rounded-lg w-full mt-4 felx block"
                onClick={() => {
                    //چک کنمی تعدادها درست باشند
                    for (const item of cart.items) {
                        if (Number(cartProducts[item.variant_id]?.metas?.stock?.value || '0') < item.qty) return
                    }
                    router.push('/cart/shipping')
                }}
            >
                انتخاب آدرس و پرداخت
            </button>
        </>
    ) : (
        <>
            <button
                type="button"
                className="bg-purple-400 text-purple-100 text-lg px-4 py-3 rounded-lg w-full mt-4 felx block"
                onClick={() => {
                    router.push('/auth/signin?returnUrl=/cart')
                }}
            >
                ورود یا ثبت نام
            </button>
        </>
    )

    return (
        <Layout menu={productCategories} footer={{ about: footer }}>
            <div className="bg-gray-200 p-4">
                <div className="lg:grid grid-col-1 px-2 gap-y-2 lg:pt-10 lg:grid-cols-4 lg:gap-2">
                    <div
                        className={`col-span-1 max-w-auto overflow-x-auto mb-10 lg:mb-0 ${
                            cart.items.length !== 0 ? 'lg:col-span-3' : 'lg:col-span-4'
                        }`}
                    >
                        <div className="overflow-x-auto overflow-y-auto scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-pink-200">
                            <div className="inline-block md:min-w-full shadow-md rounded-xl overflow-hidden">
                                {cart.items.length === 0 && (
                                    <div className="text-center">
                                        <p>هیچ کالایی در سبد خرید شما وجود ندارد </p>
                                    </div>
                                )}
                                {cart.items.length !== 0 && (
                                    <table className="min-w-full leading-normal lg:table-auto">
                                        <thead>
                                            <tr>
                                                <th
                                                    colSpan="5"
                                                    className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                                                >
                                                    محصول
                                                </th>
                                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                                    تعداد
                                                </th>
                                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                                    قیمت واحد
                                                </th>
                                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                                    قیمت نهایی
                                                </th>
                                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                                    حذف از سبد خرید
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cart.items.map(({ product_id, variant_id, qty }) => (
                                                <tr key={cartProducts[variant_id].id}>
                                                    <td
                                                        className="px-5 py-5 border-b border-gray-200 bg-white text-sm"
                                                        colSpan="5"
                                                    >
                                                        <div className="flex items-center">
                                                            <div className="flex-shrink-0 w-20 h-20">
                                                                <img
                                                                    className="w-full h-full rounded-lg"
                                                                    src={`/api/${
                                                                        cartProducts[variant_id].metas.pic_path.value
                                                                            ? cartProducts[variant_id].metas.pic_path
                                                                                  .value
                                                                            : cartProducts[product_id].metas.pic_path
                                                                                  .value
                                                                    }`}
                                                                />
                                                            </div>
                                                            <div className="mr-6">
                                                                <Link
                                                                    href={`/products/detail/${product_id}/${encodeURIComponent(
                                                                        cartProducts[product_id].name
                                                                    )}`}
                                                                >
                                                                    <a className="whitespace-no-wrap text-blue-700">
                                                                        {cartProducts[variant_id].name}
                                                                        {cartProducts[variant_id].metas?.model?.value &&
                                                                            ` مدل ${cartProducts[
                                                                                variant_id
                                                                            ].metas.model.value.replace(
                                                                                /^مدل\s?/,
                                                                                ''
                                                                            )}`}
                                                                    </a>
                                                                </Link>

                                                                {cartProducts[variant_id]?.metas?.color?.value && (
                                                                    <div className="flex flex-col  items-start mt-2 attributes">
                                                                        {Number(
                                                                            cartProducts[variant_id]?.metas?.stock
                                                                                ?.value || '0'
                                                                        ) <= 0 && (
                                                                            <div className="text-red-500">
                                                                                موجودی این کالا به پایان رسیده است
                                                                            </div>
                                                                        )}
                                                                        {Number(
                                                                            cartProducts[variant_id]?.metas?.stock
                                                                                ?.value || '0'
                                                                        ) > 0 &&
                                                                            Number(
                                                                                cartProducts[variant_id]?.metas?.stock
                                                                                    ?.value || '0'
                                                                            ) < qty && (
                                                                                <div className="text-red-500">
                                                                                    تنها{' '}
                                                                                    {
                                                                                        cartProducts[variant_id]?.metas
                                                                                            ?.stock?.value
                                                                                    }{' '}
                                                                                    {cartProducts[variant_id]?.metas
                                                                                        ?.unit?.value || 'عدد'}{' '}
                                                                                    از این کالا موجود است
                                                                                </div>
                                                                            )}
                                                                        <div className="flex items-center border rounded-md py-1 px-2 ml-2 w-auto ">
                                                                            <span
                                                                                style={{
                                                                                    backgroundColor:
                                                                                        cartProducts[variant_id].metas
                                                                                            .color.value
                                                                                }}
                                                                                className="rounded-xl w-4 h-4 border inline-flex ml-2"
                                                                            ></span>
                                                                            {
                                                                                colorMap[
                                                                                    cartProducts[variant_id].metas.color
                                                                                        .parent_id
                                                                                ].key
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center">
                                                        <div className="w-24 mx-auto">
                                                            <div className="flex">
                                                                <input
                                                                    value={qty}
                                                                    className="bg-white text-sm text-gray-900 text-center focus:outline-none border border-gray-300 h-10 focus:border-gray-400 rounded-md w-full"
                                                                    onChange={(e) =>
                                                                        updateQty(
                                                                            cartProducts[variant_id],
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                />
                                                                <div className="w-8 flex flex-col justify-items-center align-middle">
                                                                    <button
                                                                        className="w-full rounded-lg border-pink-400 text-pink-500"
                                                                        style={{ height: 20 }}
                                                                        onClick={async () => {
                                                                            updateQty(cartProducts[variant_id], '+')
                                                                        }}
                                                                    >
                                                                        <img
                                                                            className="w-full2"
                                                                            src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgZmlsbD0ibm9uZSIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiB3aWR0aD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQuNzA3MSAxMi43MDcxQzE0LjMxNjYgMTMuMDk3NiAxMy42ODM0IDEzLjA5NzYgMTMuMjkyOSAxMi43MDcxTDEwIDkuNDE0MjFMNi43MDcxMSAxMi43MDcxQzYuMzE2NTggMTMuMDk3NiA1LjY4MzQyIDEzLjA5NzYgNS4yOTI4OSAxMi43MDcxQzQuOTAyMzcgMTIuMzE2NiA0LjkwMjM3IDExLjY4MzQgNS4yOTI4OSAxMS4yOTI5TDkuMjkyODkgNy4yOTI4OUM5LjY4MzQyIDYuOTAyMzcgMTAuMzE2NiA2LjkwMjM3IDEwLjcwNzEgNy4yOTI4OUwxNC43MDcxIDExLjI5MjlDMTUuMDk3NiAxMS42ODM0IDE1LjA5NzYgMTIuMzE2NiAxNC43MDcxIDEyLjcwNzFaIiBmaWxsPSIjNEE1NTY4IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4="
                                                                        />
                                                                    </button>
                                                                    <button
                                                                        className="w-full rounded-lg border-pink-400 text-pink-500"
                                                                        style={{ height: 20 }}
                                                                        onClick={async () => {
                                                                            updateQty(cartProducts[variant_id], '-')
                                                                        }}
                                                                    >
                                                                        <img
                                                                            className="w-full2"
                                                                            src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgZmlsbD0ibm9uZSIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiB3aWR0aD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS4yOTI4OSA3LjI5Mjg5QzUuNjgzNDIgNi45MDIzNyA2LjMxNjU4IDYuOTAyMzcgNi43MDcxMSA3LjI5Mjg5TDEwIDEwLjU4NThMMTMuMjkyOSA3LjI5Mjg5QzEzLjY4MzQgNi45MDIzNyAxNC4zMTY2IDYuOTAyMzcgMTQuNzA3MSA3LjI5Mjg5QzE1LjA5NzYgNy42ODM0MiAxNS4wOTc2IDguMzE2NTggMTQuNzA3MSA4LjcwNzExTDEwLjcwNzEgMTIuNzA3MUMxMC4zMTY2IDEzLjA5NzYgOS42ODM0MiAxMy4wOTc2IDkuMjkyODkgMTIuNzA3MUw1LjI5Mjg5IDguNzA3MTFDNC45MDIzNyA4LjMxNjU4IDQuOTAyMzcgNy42ODM0MiA1LjI5Mjg5IDcuMjkyODlaIiBmaWxsPSIjNEE1NTY4IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4="
                                                                        />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center">
                                                        <Currency product={cartProducts[variant_id]} showDiscount />
                                                    </td>
                                                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center">
                                                        <Currency
                                                            product={cartProducts[variant_id]}
                                                            qty={qty}
                                                            showDiscount
                                                        />
                                                    </td>
                                                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center">
                                                        <button
                                                            onClick={() => {
                                                                cart.remove(variant_id)
                                                            }}
                                                        >
                                                            <span className="relative inline-block px-3 py-1 font-semibold text-red-900 leading-tight">
                                                                <span
                                                                    aria-hidden
                                                                    className="absolute inset-0 bg-red-200 opacity-50 rounded-full"
                                                                ></span>
                                                                <span className="relative">حذف</span>
                                                            </span>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                    {cart.items.length !== 0 && (
                        <div className="lg:order-first lg:px-0">
                            <div className="sticky top-0">
                                <CartSummary action={CartAction} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    )
}
